import {
  isValidSocketEvent,
  isEventPaused,
  pauseEvent,
  resumeEvent,
  isEventEnabled,
} from './socketManager';

export function getSocket(socketOrRef) {
  if (!socketOrRef) return null;
  if (socketOrRef.current) return socketOrRef.current;
  return socketOrRef;
}

export function addSocketListener(socketOrRef, eventName, callback, { once = false } = {}) {
  const socket = getSocket(socketOrRef);
  if (!socket || typeof socket.on !== 'function') return () => {};
  if (!isValidSocketEvent(eventName)) {
    console.warn('[socketHelpers] Attempt to register unknown socket event:', eventName);
    return () => {};
  }
  if (!isEventEnabled(eventName)) {
    console.debug('[socketHelpers] Attempt to register disabled event, skipping: ', eventName);
    return () => {};
  }

  const listener = (...args) => callback(...args);
  if (once && typeof socket.once === 'function') {
    socket.once(eventName, listener);
  } else if (typeof socket.on === 'function') {
    socket.on(eventName, listener);
  }

  return () => {
    if (!socket) return;
    if (typeof socket.off === 'function') socket.off(eventName, listener);
  };
}

export function emitSocketEvent(socketOrRef, eventName, ...payload) {
  const socket = getSocket(socketOrRef);
  if (!socket || typeof socket.emit !== 'function') return null;
  if (!isValidSocketEvent(eventName)) {
    console.warn('[socketHelpers] Attempt to emit unknown socket event:', eventName);
    return null;
  }
  if (!isEventEnabled(eventName)) {
    console.debug('[socketHelpers] Attempt to emit disabled event, skipping: ', eventName);
    return null;
  }
  if (isEventPaused(eventName)) {
    console.debug('[socketHelpers] Event currently paused, skipping emit:', eventName);
    return null;
  }
  try {
    return socket.emit(eventName, ...payload);
  } catch (err) {
    console.error('[socketHelpers] emit error', err);
    return null;
  }
}

export function pauseSocketEvent(eventName) {
  return pauseEvent(eventName);
}

export function resumeSocketEvent(eventName) {
  return resumeEvent(eventName);
}

export function isSocketEventPaused(eventName) {
  return isEventPaused(eventName);
}

export default {
  getSocket,
  addSocketListener,
  emitSocketEvent,
  pauseSocketEvent,
  resumeSocketEvent,
  isSocketEventPaused,
};
